import './App.css';
import Home from './components/Home.js';
import RestaurantExampleHome from './pages/restaurantExample/restaurantExampleHome.js'
import MissingPage from './components/MissingPage.js';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const App = () => {
    return(
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                {/* <Route path="/bar" element={<BarExampleHome />} /> */}
                <Route path="/food" element={<RestaurantExampleHome />} />
                <Route path="/*" element={<MissingPage />} />
            </Routes>
        </BrowserRouter>
    )
}

export default App;
